import AdminLayout from "@/components/admin/AdminLayout";

export default function AdminPlaceholder({ title, description }) {
  return (
    <AdminLayout title={title}>
      <div className="rounded-3xl border border-dashed border-slate-300 bg-white p-14 text-center">
        <div className="font-mono-data text-[10.5px] uppercase tracking-[0.16em] text-cyan-brand font-semibold">
          Coming in Phase 3
        </div>
        <h2 className="mt-2 font-display text-2xl md:text-3xl font-bold text-navy-deep">
          {title}
        </h2>
        <p className="mt-2 text-slate-500 max-w-md mx-auto">
          {description || "This section is scaffolded and gated behind admin auth. Full CRUD screens land in the next phase."}
        </p>
      </div>
    </AdminLayout>
  );
}
